import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Droplet } from "lucide-react";
import { Flag } from "@/components/Flag";
import { FooterNewsletter } from "@/components/FooterNewsletter";

export const Footer = () => {
  const { t } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="border-t border-border bg-[#2C3518] text-white/80">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent text-accent-foreground">
                <Droplet className="h-5 w-5" fill="currentColor" />
              </span>
              <span className="font-serif text-2xl font-bold text-white">
                Evoo<span className="text-accent">Tunisia</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/60">{t("footer.about")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white">{t("footer.marketplace")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/marche/vrac" className="transition-colors hover:text-accent">{t("nav.market.bulk")}</Link></li>
              <li><Link to="/marche/conditionne" className="transition-colors hover:text-accent">{t("nav.market.packaged")}</Link></li>
              <li><Link to="/prix" className="transition-colors hover:text-accent">{t("nav.prices")}</Link></li>
              <li><Link to="/annuaire" className="transition-colors hover:text-accent">{t("nav.directory")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white">{t("footer.legal")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/legal/cgu" data-testid="footer-cgu" className="transition-colors hover:text-accent">{t("footer.cgu")}</Link></li>
              <li><Link to="/legal/confidentialite" data-testid="footer-privacy" className="transition-colors hover:text-accent">{t("footer.privacy")}</Link></li>
              <li><Link to="/legal/cookies" data-testid="footer-cookies" className="transition-colors hover:text-accent">{t("footer.cookies")}</Link></li>
              <li><Link to="/blog" className="transition-colors hover:text-accent">{t("nav.blog")}</Link></li>
              <li><Link to="/faq" data-testid="footer-faq" className="transition-colors hover:text-accent">{t("nav.faq")}</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="transition-colors hover:text-accent">{t("nav.contact")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white">{t("footer.company")}</h4>
            <p className="mt-4 text-sm text-white/60">{t("footer.newsletter")}</p>
            <FooterNewsletter />
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-sm text-white/50 sm:flex-row">
          <p>© {year} EvooTunisia. {t("footer.rights")}</p>
          <p className="inline-flex items-center gap-1.5">Tunisie <Flag code="TN" /> · TND / EUR / USD</p>
        </div>
      </div>
    </footer>
  );
};
